module.exports = __webpack_public_path__ + "img/howtoplay-03.3a5c77ae.jpg";